import React, { useEffect, useState } from "react";
import { HiChevronRight, HiOutlineSearch } from "react-icons/hi";
import { IoEyeOutline } from "react-icons/io5";
import { PiPlusBold } from "react-icons/pi";
import { Link } from "react-router-dom";

import { formatCreatedAt } from "../../utils/commonUtils";

import { useDispatch, useSelector } from "react-redux";

import { fetchStore } from "../../redux/slices/storeSlice";

import ModalDeleteStore from "../../components/modals/modalStore/ModalDeleteStore";
import { ImSpinner2 } from "react-icons/im";
import ModalUpdateStore from "../../components/modals/modalStore/ModalUpdateStore";
import OpenStore from "../../components/modals/modalStore/OpenStore";
import CloseStore from "../../components/modals/modalStore/CloseStore";

const Stores = () => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("all"); // "all", "open", "closed"
  const itemsPerPage = 10; // Number of items to display per page

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchStore());
  }, [dispatch]);

  const stores = useSelector((state) => state.store?.stores);

  const storedUser = JSON.parse(localStorage.getItem("user"));
  
  const isSuperAdmin = storedUser.role === "Super Admin";

  // Filter stores based on search term and status filter
  const filteredStores = stores.filter((store) => {
    // Apply search filter
    const searchMatch = search.trim() === "" 
      ? true 
      : store?.name?.toLowerCase().includes(search.toLowerCase());

    // Apply status filter
    let statusMatch = true;
    if (statusFilter === "open") {
      statusMatch = store.closed !== "1";
    } else if (statusFilter === "closed") {
      statusMatch = store.closed === "1";
    }

    return searchMatch && statusMatch;
  });

  // Calculate the index of the first and last item to display on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentStores = filteredStores.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredStores.length / itemsPerPage);

  // Function to handle pagination
  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const status = useSelector((state) => state.store?.status);
  const error = useSelector((state) => state.store?.error);

  const countries = JSON.parse(localStorage.getItem("country"));
  const states = JSON.parse(localStorage.getItem("state"));
  const provinces = JSON.parse(localStorage.getItem("province"));

  const getCountryNameById = (countryId) => {
    const parsedId = parseInt(countryId, 10);
    const country = countries.find((country) => country.id === parsedId);

    return country ? country.name : "Unknown";
  };

  const getStateNameById = (stateId) => {
    const parsedId = parseInt(stateId, 10);

    const state = states.find((state) => state.id === parsedId);

    return state ? state.name : "Unknown";
  };

  const getCityNameById = (cityId) => {
    const parsedId = parseInt(cityId, 10);
    const city = provinces.find((city) => city.id === parsedId);

    return city ? city.name : "Unknown";
  };

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h1 className="w-full h-auto text-2xl mb-2 text-[#333843] font-medium">
            Stores
          </h1>

          <div className="flex mb-4 justify-center items-center gap-2 mt-4">
            <Link to="/dashboard">
              <p className="text-[14px] text-[#1F7BF4] font-medium hover:underline">
                Dashboard
              </p>
            </Link>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#1F7BF4]  font-medium">Store</p>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#667085] font-medium">Stores</p>
          </div>
        </div>
      </div>
      
      <div className="flex mt-4 justify-between mb-4">
        <div className="flex gap-4">
          <button className="relative w-72">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <HiOutlineSearch className=" text-gray-500 text-2xl" />
            </div>
            <input
              type="text"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
              placeholder="Search ..."
              onChange={(e) => setSearch(e.target.value)}
            />
          </button>
          
          {/* Status Filter Dropdown */}
          <div className="relative">
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-40 p-2.5 appearance-none"
            >
              <option value="all">All Stores</option>
              <option value="open">Open Stores</option>
              <option value="closed">Closed Stores</option>
            </select>
            {/* <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div> */}
          </div>
        </div>

        <div className="flex items-center gap-4">
          <Link to="/dashboard/shopping/add-store">
            <button
              type="button"
              className="flex gap-[8px] bg-[#1F7BF4] text-white items-center py-2 px-4 text-[14px] hover:shadow-lg rounded-[8px] font-medium"
            >
              <PiPlusBold className=" text-lg font-extrabold" />
              Add Store
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-white rounded-lg w-full p-4 h-auto shadow-md">
        <div className="relative overflow-x-auto rounded-t-lg">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="w-full text-sm text-gray-700 bg-gray-50 whitespace-nowrap">
              <tr>
                <th className="px-4 py-4 text-center">No.</th>
                <th className="px-12 py-4 text-center">Image</th>
                <th className="px-4 py-4 text-center">Name</th>
                <th className="px-4 py-4 text-center">Country</th>
                <th className="px-4 py-4 text-center">State</th>
                <th className="px-4 py-4 text-center">City</th>
                <th className="px-4 py-4 text-center">Status</th>
                <th className="px-4 py-4 text-center">Short Text</th>
                <th className="px-4 py-4 text-center">Location</th>
                <th className="px-4 py-4 text-center">Created</th>
                <th className="px-4 py-4 text-center">Status</th>
                <th className="px-4 py-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody className="w-full text-sm text-gray-700">
              {status === "failed" ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      Error. {error}.{" "}
                      <span className="text-base font-semibold ">
                        {" "}
                        Try again later
                      </span>
                    </div>
                  </td>
                </tr>
              ) : status === "loading" ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      <ImSpinner2 className="animate-spin h-8 w-8 text-gray-500" />
                    </div>
                  </td>
                </tr>
              ) : currentStores.length === 0 ? (
                <tr>
                  <td colSpan="12" className="text-center text-gray-500 py-4">
                    No Data
                  </td>
                </tr>
              ) : (
                currentStores?.map((store, index) => (
                  <tr key={index} className="bg-white border-b">
                    <td className="px-4 py-4">
                      <div className="flex justify-center items-center">
                        <p className=" text-base text-center font-semibold ">
                          {indexOfFirstItem + index + 1}
                        </p>
                      </div>
                    </td>

                    <td className="px-2 py-2">
                      <div className="flex items-center p-2 justify-center">
                        <img
                          src={store.image}
                          alt="store"
                          className="w-24 h-24 object-cover rounded-lg"
                        />
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <Link
                        to={`/dashboard/shopping/stores/${store.id}?page=1`}
                      >
                        <div className="ml-2">
                          <p className="text-blue-600 text-center font-semibold w-48 break-words">
                            {store.name}
                          </p>
                        </div>
                      </Link>
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {getCountryNameById(store.country)}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {getStateNameById(store.state)}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {getCityNameById(store.province)}
                    </td>
                    <td className="px-4 py-4 text-center">{store.type}</td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {store.landmark}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {store.location}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {formatCreatedAt(store.created_at)}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {store.closed === "1" ? (
                        <OpenStore id={store.id} name={store.name} />
                      ) : (
                        <CloseStore id={store.id} name={store.name} />
                      )}
                    </td>

                    <td className="px-2 py-2">
                      <div className="flex gap-4 justify-center">
                        <Link
                          to={`/dashboard/shopping/stores/${store.id}?page=1`}
                        >
                          <IoEyeOutline className="w-4 h-4 text-[#667085]" />
                        </Link>
                        {isSuperAdmin  && 
                        <ModalUpdateStore
                          id={store.id}
                          image={store.image}
                          name={store.name}
                          note={store.note}
                          landmark={store.landmark}
                          location={store.location}
                          type={store.type}
                          country={store.country}
                          state={store.state}
                          province={store.province}
                        /> }
                        {isSuperAdmin &&  
                        <ModalDeleteStore
                          id={store.id}
                          image={store.image}
                          name={store.name}
                          landmark={store.landmark}
                          location={store.location}
                          type={store.type}
                          country={getStateNameById(store.country)}
                          state={getStateNameById(store.state)}
                          cities={getCityNameById(store.province)}
                        /> }
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between px-[24px] py-[15px] items-center">
          <p className="text-[14px] py-4 font-medium text-[#667085] tracking-[0.07px]">
            Showing {indexOfFirstItem + 1} - {indexOfLastItem} from{" "}
            {filteredStores.length} stores
            {statusFilter !== "all" && ` (${statusFilter})`}
          </p>

          <div className="flex gap-[8px]">
            <button
              onClick={prevPage}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded-md ${
                currentPage === 1
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
            >
              Previous
            </button>

            <button
              onClick={nextPage}
              disabled={currentPage === totalPages}
              className={`px-4 py-2 rounded-md ${
                currentPage === totalPages
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stores;